// ═══════════════════════════════════════════════════════════
// MAIN ENTRY POINT - Corner Bouncer
// ═══════════════════════════════════════════════════════════

import { Game } from './Game.js';

// Wait for DOM to be ready
window.addEventListener('DOMContentLoaded', () => {
    const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

    if (!canvas) {
        console.error('Canvas element not found!');
        return;
    }

    // Initialize and start the game
    try {
        new Game(canvas);
        console.log('🎮 Corner Bouncer initialized successfully!');
    } catch (error) {
        console.error('Failed to initialize game:', error);
    }
});
